import { render, staticRenderFns } from "./ProfileMediaPage.vue?vue&type=template&id=1efc9c7c&"
import script from "./ProfileMediaPage.vue?vue&type=script&lang=js&"
export * from "./ProfileMediaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports